import { IconButton, IconName, Position } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { RoleGetResult } from '@mews-commander/data-access';
import { TooltippedSpan } from '@mews-commander/ui';
import { useRemoveRoleUsers } from './queries';

export const RemoveUserCell = ({
    role,
    userId,
    onDelete,
    isProvisioned,
}: {
    role: RoleGetResult;
    userId: string;
    onDelete?: () => void;
    isProvisioned?: boolean;
}) => {
    const { mutate: removeUsers } = useRemoveRoleUsers(role.name);

    return (
        <TooltippedSpan
            tooltip={isProvisioned ? <LocalizedText textKey={TextKey.RoleDeleteProvisionedUserTooltip} /> : null}
            tooltipDelay={300}
            tooltipPosition={Position.Left}
        >
            <IconButton
                icon={IconName.Delete}
                onClick={() => {
                    removeUsers({ userIds: [userId], roleId: role.id }, { onSuccess: () => onDelete?.() });
                }}
                size="small"
                variant="ghost"
                disabled={isProvisioned}
                type="submit"
            />
        </TooltippedSpan>
    );
};
